import api from 'config/api.config';
import { getErrorMessage } from 'utils/errors';

/**
 * Fetch story settings logs for a specific account.
 * @param account_id - The ID of the account.
 * @returns - The story settings logs data.
 */
export const getStorySettingsLogs = async (
  account_id: string,
  page?: number,
  limit?: number,
  date?: string
): Promise<any> => {
  try {
    const body: Record<string, unknown> = { account_id };
    if (page !== undefined) body.page = page;
    if (limit !== undefined) body.limit = limit;
    if (date) body.date = date;

    const response = await api.post(
      '/api/actions/story/story-settings-logs',
      body
    );

    return response.data;
  } catch (error: unknown) {
    throw new Error(getErrorMessage(error, 'Failed to fetch story settings logs'));
  }
};
